import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Avatar } from '@fiverr-private/fit';
import { Image } from '@fiverr-private/media';
import { I18n } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { useStaticContext, selectRecipientInfo, selectShowSpokenLanguages } from '../../context/contexts/static';
import { MessageSeller } from '../MessageSeller';
import ResponseTime from '../ResponseTime';
import SpokenLanguages from '../SpokenLanguages';
import classes from './style.module.scss';

const MORPHEUS_ICON_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/4451d1448c79c79af3c6da9d23ba16f1-1739545902465/personal%20assistant%20logo.png';

const RecipientInfo = ({
    className,
    responseTimeClassName,
    messageSellerClassName,
    avatarClassName,
    titleOnly = false,
    compactView = false,
    isAssistantActive = false
}) => {
    const context = useStaticContext();
    const { username, profilePhoto, isOnline, proficientLanguages } = selectRecipientInfo(context);
    const showSpokenLanguages = selectShowSpokenLanguages(context);

    const wrapperClasses = classNames(
        classes.sellerInfo,
        className,
        'flex',
        {
            'flex-col p-16': compactView,
            [classes.compactView]: compactView
        }
    );

    return (
        <>
            <div className={wrapperClasses}>
                {titleOnly ? (
                    <MessageSeller className={messageSellerClassName}/>
                ) : (
                    <>
                        <div data-testid="avatar">
                            <Avatar containerClassName={avatarClassName} username={username} size={48} src={profilePhoto} showOnlineIndicator isOnline={isOnline}/>
                        </div>
                        <div className={classNames('flex', 'flex-col', 'tbody-6', { 'p-l-16': !compactView, 'p-t-8': compactView })}>
                            <MessageSeller className={messageSellerClassName} compactView={compactView}/>
                            {isAssistantActive ? (
                                <Stack direction="row" alignItems="center" gap="1">
                                    <Image width="16px" height="16px" alt="morpehus icon" src={MORPHEUS_ICON_URL}/>
                                    <I18n k="send_message.personal_assistant"/>
                                </Stack>
                            ) : (
                                <ResponseTime className={classNames(responseTimeClassName, 'co-grey-1000')}/>
                            )}
                            {showSpokenLanguages && <SpokenLanguages proficientLanguages={proficientLanguages}/>}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

RecipientInfo.propTypes = {
    className: PropTypes.string,
    responseTimeClassName: PropTypes.string,
    messageSellerClassName: PropTypes.string,
    avatarClassName: PropTypes.string,
    titleOnly: PropTypes.bool,
    compactView: PropTypes.bool,
    isAssistantActive: PropTypes.bool
};

export default RecipientInfo;
